import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [authed, setAuthed] = useState(location.state?.user ? true : null);
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    if (location.state?.user) return;
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then((res) => {
        setUser(res.data);
        setAuthed(true);
      })
      .catch(() => {
        setAuthed(false);
        navigate("/login", { replace: true });
      });
  }, [location.state, navigate]);

  if (authed === null) {
    return (
      <div className="min-h-screen bg-[#0a0b0a] flex items-center justify-center">
        <div className="flex items-center gap-3 text-[#9ca399]">
          <Loader2 size={20} className="animate-spin text-[#b89b72]" /> Loading…
        </div>
      </div>
    );
  }

  if (!authed) return null;

  return typeof children === "function" ? children(user) : children;
}
